// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__yHZpd","item":"PaymentsMobile_item__3tFIJ","label":"PaymentsMobile_label__2J7RH","amount":"PaymentsMobile_amount__h9aD7"};